/**
 * Quebra o que a pessoa colou num campo de "uma por linha" em itens.
 *
 * O separador é a QUEBRA DE LINHA (`\n` ou `\r\n`) e só ela: premissa é
 * frase e pode ter `;` e vírgula dentro, então `splitEntries` não serve.
 * Tira espaços das pontas e descarta linha vazia ou só de espaço. Não
 * remove repetidos: duas premissas iguais são problema do servidor, não
 * da quebra.
 */
export function splitLines(raw: string): string[] {
  return raw
    .split(/\r?\n/)
    .map(line => line.trim())
    .filter(line => line.length > 0);
}
